(() => {
  const root = document.getElementById('kiphy-duftberater')?.shadowRoot;
  if (!root) return;
  const launcher = root.querySelector('.launcher');
  if (launcher) {
    launcher.setAttribute('aria-label', 'Duftberater öffnen');
    launcher.setAttribute('title', 'Deinen Duft finden');
    const label = document.createElement('span');
    label.className = 'launcher-label';
    label.textContent = 'Deinen Duft finden';
    for (const node of [...launcher.childNodes]) {
      if (node.nodeType === Node.TEXT_NODE) node.remove();
    }
    launcher.prepend(label);
    launcher.classList.add('launcher-intro');
    const collapse = () => launcher.classList.remove('launcher-intro');
    setTimeout(collapse, 5000);
    launcher.addEventListener('click', collapse, { once: true });
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('class', 'mobile-chat-icon');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<path d="M20 11.5a8 8 0 0 1-8 8 9 9 0 0 1-3.5-.7L4 20l1.2-4.5A9 9 0 0 1 4.5 12a8 8 0 0 1 8-8H13a7.5 7.5 0 0 1 7 7v.5Z"/><path d="M8 10h8M8 14h5"/>';
    launcher.append(icon);
  }
  const style = document.createElement('style');
  style.textContent = `
    .floating{right:130px}
    .mobile-chat-icon{display:none}
    .launcher .launcher-label{margin:0;font-size:inherit}
    @media(max-width:800px){
      .floating{right:10px;left:auto;bottom:calc(140px + env(safe-area-inset-bottom,0px))}
      .floating .launcher{position:relative;width:48px;height:48px;padding:0;border-radius:24px;font-size:0;display:flex;align-items:center;justify-content:flex-end;overflow:hidden;transition:width .35s ease}
      .floating .launcher span{display:none}
      .floating .launcher .launcher-label{display:block;position:absolute;right:48px;white-space:nowrap;font-size:14px;opacity:0;transition:opacity .15s ease}
      .floating .launcher-intro{width:198px}
      .floating .launcher-intro .launcher-label{opacity:1}
      .floating .mobile-chat-icon{display:block;flex-shrink:0;margin-right:11.5px;width:25px;height:25px;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}
      .floating .panel{width:calc(100vw - 24px);height:calc(100dvh - 164px - env(safe-area-inset-bottom,0px));max-height:700px}
    }
    @media(prefers-reduced-motion:reduce){.floating .launcher,.floating .launcher .launcher-label{transition:none}}
  `;
  root.append(style);
})();
